import { AdditionalInformation } from './AdditionalInformation';
import { App } from 'App';
import {
  Card,
  LinkActor,
  PersonIcon,
  RightArrowIcon,
  Row,
  ShieldIcon,
  Spacer,
  Text,
  Title,
} from 'internalLibrary';
import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { WarningRed2Icon } from 'assets';
import layout from '../../../../scss/layout.module.scss';
import LoanApplicationProcessLayout from 'ui/components/LoanApplicationProcessLayout';
import RegisterForm from './RegisterForm';
import styles from './RegisterScene.module.scss';
import useAuth from 'ui/hooks/useAuth';

export function RegisterScene() {
  const navigate = useNavigate();
  const { isLoggedIn } = useAuth();
  const { t } = useTranslation();
  const tr = App.translateContent('leftPanel');

  const loginLinkClicked = useCallback(() => {
    navigate('/login');
  }, []);

  useEffect(() => {
    document.title = t('firstLoanRegister_title');
  }, [t]);

  return (
    <LoanApplicationProcessLayout>
      <div className={layout['width-lg']}>
        <Spacer marginBottom={{ default: '40px', s: '35px' }}>
          <Title
            className={styles.heading}
            text={t('firstLoanRegister_title')}
            data-test="css-Contact-Data-Title"
          />
        </Spacer>
        <Spacer marginBottom="40px" className={styles['login-section']}>
          <Spacer marginBottom="10px">
            <Title
              text={t('areYouClient')}
              className={styles.subheading}
              data-test="xpath-AreYou-Client"
            />
          </Spacer>

          {!isLoggedIn && (
            <LinkActor
              linkProps={{
                onClick: loginLinkClicked,
                leftIcon: <PersonIcon />,
                rightIcon: <RightArrowIcon />,
                className: styles['login-button'],
                dataTest: 'css-Init-Session',
              }}
            >
              {t('login_login')}
            </LinkActor>
          )}
        </Spacer>
        <RegisterForm />
        <div className={styles.notice}>
          <Text
            className={styles.representative}
            dangerouslySetInnerHTML={{ __html: tr.representativeExample }}
            kind="p"
          />
          <WarningRed2Icon className={styles['warning-icon']} />
          <h4>{tr.highCostCredit}</h4>
          <Text
            kind="p"
            dangerouslySetInnerHTML={{
              __html: tr.highCostCreditDescription,
            }}
          />
        </div>
        <div className={layout['width-lg']}>
          <Spacer marginTop="45px">
            <Row>
              <div>
                <ShieldIcon />
              </div>
              <Spacer paddingLeft="10px">
                <Text
                  text={t('firstLoanRegister_securityNotice')}
                  kind="span"
                  level={3}
                  data-test="css-Secure-Info"
                />
              </Spacer>
            </Row>
          </Spacer>
        </div>
        <Spacer marginTop="45px">
          <Card intent="success">
            <Spacer margin="24px">
              <AdditionalInformation />
            </Spacer>
          </Card>
        </Spacer>
      </div>
    </LoanApplicationProcessLayout>
  );
}

export default RegisterScene;
